import { html, repeat } from '@microsoft/fast-element';
import type { UploadValidation } from './upload-validation';

export const UploadValidationTemplate = html<UploadValidation>`
  <div class="table-container">
    ${repeat(
      (x) => x.errorProjectList,
      html`
        <error-upload-grid :errorProject=${(x) => x}></error-upload-grid>
      `
    )}
    <div></div>
  </div>
`;
